export default {
  identityInformation: {
    title: "اطلاعات هویتی",
    rejectReason: "دلیل رد احراز هویت:",
    quickVerification: `اگر می‌خواهید سریع‌تر احراز هویت شوید،پیشنهاد می‌کنیم از اپلیکیشن استفاده کنید.`,
    quickVerificationButton: "متوجه شدم",
    getOTP: "دریافت کد تایید",
    submitButton: "ادامه",
    personalStatus: {
      verified: "احراز هویت شما بطور کامل تکمیل شده است",
      progress: {
        title: "احراز هویت شما تکمیل نشده است",
        subtitle:
          "با تکمیل احراز هویت خود، می‌توانید واریز و برداشت ریالی داشته باشید.",
        steps: {
          contactInfo: "اطلاعات تماس",
          personalInfo: "اطلاعات فردی",
          identityInfo: "شناسایی هویت",
          internationalCardImage: "عکس کارت ملی",
          confirmKyc: "تایید احراز هویت"
        }
      }
    },
    contactInfo: {
      headerTitle: "تایید اطلاعات تماس",
      title: "اطلاعات تماس",
      mobile: {
        title: "شماره موبایل",
        verified: "تایید شده",
        unverified: "تایید نشده",
        verifyMobileButton: "تایید شماره موبایل*",
        submitButton: "ثبت",
        validations: {
          emptyPassword: "رمز عبور را وارد کنید",
          invalidCode: "کد پیامک شده نا معتبر است",
          emptyCode: "کد پیامک شده را وارد کنید"
        },
        modals: {
          getMobileNumber: {
            title: "تایید شماره موبایل",
            subtitle: "شماره موبایل خود را وارد کنید",
            inputLabel: "شماره موبایل",
            inputExample: "مثلا 09123456789",
            submitButton: "ادامه",
            mobileValidation: {
              invalid: "شماره موبایل نامعتبر است"
            }
          },
          getVerificationCode: {
            title: " کد ارسال شده به {n} را وارد کنید.",
            inputPlaceholder: "کد پیامک شده",
            getVerificationCodeAgainButton: "دریافت مجدد کد تایید",
            getVerificationCodeAgainTitle: "ارسال مجدد کد تا",
            getVerificationCodeAgainSecondsTitle: "ثانیه دیگر",
            submitButton: "تایید",
            previousStep: "مرحله قبل"
          }
        }
      },
      phone: {
        title: "شماره ثابت",
        verified: "تایید شده",
        unverified: "تایید نشده",
        verifyPhoneButton: "تایید شماره ثابت",
        submitButton: "ثبت",
        phoneValidation: {
          invalid: "شماره تلفن نامعتبر است",
          empty: "شماره تلفن را وارد کنید"
        },
        modals: {
          getPhoneNumber: {
            title: "تایید شماره تماس ثابت",
            subtitle: "شماره تماس به همراه کد شهر خود را وارد کنید",
            inputLabel: " شماره ثابت",
            submitButton: "ادامه",
            inputExample: "شماره تلفن و کد شهر، مثلا: 02123456789"
          },
          getVerificationCode: {
            title:
              " کد 6 رقمی که از طریق تماس تلفنی، با شماره ({n}) برای شما خوانده می‌شود را در کادر زیر وارد کنید",
            inputPlaceholder: "کد دریافتی",
            getVerificationCodeAgainButton: "دریافت مجدد کد تایید",
            getVerificationCodeAgainTitle: "ارسال مجدد کد تا",
            getVerificationCodeAgainSecondsTitle: "ثانیه دیگر",
            submitButton: "تایید",
            previousStep: "مرحله قبل"
          }
        }
      },
      email: {
        title: "ایمیل",
        verified: "تایید شده",
        unverified: "تایید نشده",
        verifyEmailButton: "تایید ایمیل",
        submitButton: "ثبت",
        emailValidation: {
          invalid: "ایمیل نامعتبر است",
          empty: "ایمیل را وارد کنید"
        },
        modals: {
          getEmail: {
            title: "تایید آدرس ایمیل",
            subtitle: "ایمیل خود را وارد کنید",
            inputLabel: "ایمیل",
            submitButton: "ادامه",
            inputExample: "مثلا user@gmail.com"
          },
          getVerificationCode: {
            title: "برای دریافت کد تایید بر روی دکمه ”دریافت کد“ بزنید",
            inputPlaceholder: "کد تایید ایمیل",
            getVerificationCodeAgainButton: "دریافت کد",
            getVerificationCodeAgainTitle: "ارسال مجدد کد تا",
            getVerificationCodeAgainSecondsTitle: "ثانیه دیگر",
            submitButton: "تایید",
            previousStep: "مرحله قبل"
          }
        }
      }
    },
    personalInformation: {
      title: "اطلاعات فردی",
      verified: "تاییدشده",
      pending: "در حال بررسی",
      edit: "ویرایش",
      submit: "ثبت",
      fullName: "نام و نام خانوادگی",
      nationalCode: "کد ملی/فراگیر",
      dateOfBirth: "تاریخ تولد",
      authUnavailable:
        "سرویس احراز هویت به صورت موقت غیرفعال است لطفا مدتی بعد مجدد تلاش کنید",
      pictureVerify: {
        title: "عکس احراز هویت",
        validation: {
          part1: "برای ثبت عکس احراز هویت، ابتدا",
          part2: "بخش اطلاعات فردی را تکمیل کنید"
        }
      },
      modals: {
        getPersonalInfo: {
          title: "ثبت اطلاعات فردی",
          subtitle: "اطلاعات فردی را مطابق با مدرک شناسایی‌تان وارد کنید",
          firstNameLabel: "نام",
          lastNameLabel: "نام خانوادگی",
          nationalCodeLabel: "کد ملی",
          dateLabel: "تاریخ تولد",
          submitButton: "ثبت",
          typeOfUser: "نوع کاربر"
        }
      },
      validation: {
        noValid: "معتبر نیست",
        firstNameRequired: "اجباری است",
        firstNamePersianRequired: "نام خود را فارسی وارد کنید",
        lastNameRequired: "نام خانوادگی اجباری است",
        lastNamePersianRequired: "نام خانوادگی خود را فارسی وارد کنید",
        birthDayRequired: "تاریخ تولد اجباری است",
        nationalCodeRequired: "کد ملی اجباری است",
        nationalCodeValidation: "کد ملی معتبر نیست"
      },
      hints: {
        firstName: "نام با حروف فارسی و مطابق با کارت ملی",
        lastName: "نام خانوادگی دقیقا مطابق با کارت ملی",
        nationalCode: "مثلا: 0011283927"
      }
    },
    personalPicture: {
      title: "شناسایی هویت",
      hasIdentityTitle:
        "ﺑﺮای ارﺳﺎل ﻋﮑﺲ شناسایی ﻫﻮﯾﺖ، اﺑﺘﺪا هر دو ﺑﺨﺶ اﻃﻼﻋﺎت تماس و اطلاعات فردی را ﺗﮑﻤﻴﻞ ﮐﻨﻴﺪ",
      isPendingTitle:
        "ممکن است پروسه تایید عکس احراز هویت کمی طولانی شود. از صبر و شکیبایی شما متشکریم.",
      verified: "تاییدشده",
      pending: "در حال بررسی",
      submit: "ثبت",
      modals: {
        getPersonalPicture: {
          title: "عکس احراز هویت",
          subtitle:
            "برای تایید مشخصات فردی، یک عکس مانند نمونه و طبق موارد خواسته شده، بارگذاری و ارسال کنید",
          uploadButton: "ارسال",
          uploadInputFile: "بارگذاری عکس احراز هویت",
          uploadGuideLine: "راهنمای بارگذاری عکس احراز هویت",
          guideLineParagraph:
            "در عکس ارسالی، اصل کارت ملی هوشمند خود را همراهِ یادداشتی دست‌نویس با متن زیر، کنار چهره‌تان نگه دارید.",
          textTitle: "متن یادداشت",
          mainText:
            "اینجانب قوانین سایت اکسکوینو‌ را مطالعه کرده و ضمن قبولی تمامی موارد ، مسئولیت خرید و فروش‌های خود را می‌پذیرم و متعهد می‌شوم حساب کاربری و کارت بانکی خود را در اختیار شخص دیگری قرار‌ نمی‌دهم و اعتراضی به قوانین سایت نخواهم داشت.",
          dateAndSignature: "تاریخ و امضا",
          guideLineParagraph2:
            "کادر عکس را طوری تنظیم کنید که مشخص باشد خودتان مدارک را در دست گرفته‌اید.",
          guideLineParagraph3:
            "متن یادداشت، مدرک شناسایی و کل عکس باید کاملا واضح، بدون تاری یا افکت باشد.",
          guideLineParagraph4:
            "حجم عکس، حداقل 100 کیلوبایت و حداکثر 24.10 مگابایت باشد.",
          takingPictureGuideLine: "نمونه عکس ارسالی",
          validFormatsTitle: "فرمت مجاز فایل:",
          invalidFormatFiles: "فرمت فایل درست نیست.",
          minFileSizeValidation:
            "حجم فایل ضمیمه شده نباید کمتر از ۱۰۰ کیلوبایت باشد.",
          maxFileSizeValidation:
            "حجم فایل ضمیمه شده نباید بیشتر از ۱۰ مگابایت باشد."
        }
      }
    },
    autoVerification: {
      title: "شناسایی هویت",
      isRejectTitle:
        "شناسایی هویت شما تایید نشد، برای انجام دوباره، لطفا از طریق اپلیکیشن اقدام کنید.",
      changeIdentificationMethod: "change identification method",
      orManual1: "یا از",
      orManual2: "استفاده کنید.",
      manualIdentification: "شناسایی هویت عادی",
      verified: "تایید شده",
      pending: "درحال بررسی",
      unverified: "تایید نشده",
      submit: "ثبت",
      modals: {
        changeIdentificationMethod: {
          title: "تغییر روش شناسایی هویت",
          subtitle:
            "آیا مطمئن هستید که می‌خواهید از ”شناسایی هویت عادی“ استفاده کنید؟ در صورت تایید، 'روند شناسایی هویت' سریع لغو می‌شود.",
          confirmButton: "تایید",
          cancelButton: "انصراف"
        }
      }
    },
    internationalCard: {
      headerTitle: "تایید و بررسی کارت ملی",
      headerDescription:
        "تصویر و اطلاعات کارت ملی خود را تایید یا در صورت مغایرت اطلاعات، ویرایش کنید.",
      internationalCardGuidTitle: "راهنمای عکس کارت‌ ملی",
      internationalCardGuidText: "حتما مطالعه شود"
    }
  },
  bankInformation: {
    title: "اطلاعات بانکی",
    bankCards: {
      title: "کارت‌های بانکی",
      addCardsButton: "افزودن کارت جدید",
      empty: "هیچ کارت بانکی ثبت نکرده‌اید",
      modals: {
        addCards: {
          title: "افزودن کارت بانکی جدید",
          subtitle: "دقت کنید، کارتی که ثبت می کنید باید به اسم خودتان باشد.",
          cardLabel: "شماره کارت",
          invalidInputCard: "شماره کارت نامعتبر است",
          emptyInputCard: "شماره کارت را وارد کنید",
          addCardButton: "بررسی و افزودن کارت"
        },
        deleteCard: {
          title: "حذف شماره کارت",
          subtitle: "آیا مطمئن هستید می‌خواهید این شماره را حذف کنید؟",
          deleteButton: "مطمئنم، حذفش کن",
          cancelButton: "انصراف از حذف"
        }
      }
    },
    shebaCards: {
      title: "آدرس‌های شبا",
      addCardsButton: "افزودن آدرس شبا",
      empty: "هیچ آدرس شبایی ثبت نکرده‌اید",
      modals: {
        addCards: {
          title: "افزودن شماره شبا",
          subtitle:
            "دقت کنید، شماره شبایی که ثبت می کنید باید به اسم خودتان باشد.",
          titleInputLabel: "عنوان",
          shebaInputLabel: "شماره شبا",
          emptyTitleInputCard: "عنوان را وارد کنید",
          invalidShebaInputCard: "شماره شبا نامعتبر است",
          emptyShebaInputCard: "شماره شبا را وارد کنید",
          addCardButton: "بررسی و افزودن شماره شبا"
        },
        deleteCard: {
          title: "حذف شماره شبا",
          subtitle: " این شماره شبا را حذف می‌کنید؟",
          deleteButton: "حذف",
          cancelButton: "انصراف"
        }
      }
    }
  },
  security: {
    title: "امنیت حساب",
    removeAccountTitle: "حذف حساب کاربری",
    removeAccountBtn: "حذف اکانت",
    sureToRemove: "آیا از حذف اکانت خود مطمین هستید؟",
    yes: "بله",
    no: "خیر",
    change: "تغییر",
    delete: "حذف",
    removeAccountWarning:
      "با ارزش‌گذاری به حریم خصوصی شما و تلاش برای ارائه کنترل بر روی داده‌هایتان، اگر این پیام را تأیید کنید، حساب کاربری خود را از برنامه‌ی ما حذف خواهید کرد. حساب کاربری شما به مدت ۱۵ روز غیرفعال خواهد شد و در صورتی که در ۱۵ روز آینده وارد حساب کاربری خود نشوید، به صورت خودکار حذف خواهد شد. با درخواست شما برای حذف حساب کاربری، تمام اطلاعات شخصی مرتبط با حساب شما حذف خواهد شد، به جز سوابق مالی مورد نیاز برای مقاصد قانونی و حسابرسی. این شامل موارد زیر می‌شود: - جزئیات شخصی (نام، ایمیل، شماره موبایل) - اطلاعات پروفایل لطفا توجه داشته باشید که ممکن است برخی از سوابق مالی را به منظور رعایت قوانین و مقررات مربوطه، برای دوره‌ای لازم برای حسابرسی و اهداف قانونی، نگهداری کنیم. اگر از این درخواست مطمئن هستید، لطفا گزینه حذف اکانت را انتخاب نمایید.",
    twoFactorAuth: {
      title: "مولفه‌های امنیتی",
      subtitle:
        "برای افزایش امنیت دارایی‌هایتان (هنگام برداشت، خرید و...)، پیشنهاد می‌کنیم ورود دو مرحله‌ای را فعال کنید.",
      SMSAuthentication: {
        title: "تایید با موبایل",
        defaultRadioButton: "پیش‌فرض",
        inactiveButton: "غیر فعال کردن",
        activeButton: "فعال سازی"
      },
      emailAuthentication: {
        title: "تایید با ایمیل",
        defaultRadioButton: "پیش‌فرض",
        inactiveButton: "غیر فعال کردن",
        activeButton: "فعال سازی"
      },
      googleAuthenticator: {
        title: "تایید با گوگل (Google Authenticator)",
        defaultRadioButton: "پیش‌فرض",
        inactiveButton: "غیر فعال کردن",
        activeButton: "فعال سازی"
      },
      activeAuthenticator: {
        title: "ورود دو مرحله‌ای (2FA)",
        defaultTitle: "انتخاب‌شده",
        defaultItems: {
          sms: "با موبایل",
          email: "با ایمیل",
          google2fa: "با گوگل"
        },
        inactiveButton: "غیر فعال کردن",
        activeButton: "فعال سازی"
      },
      otpSetting: {
        title: "تنظیمات OTP",
      },
      loginWith2fa: {
        title: "ورود دو مرحله‌ای (2FA)",
        subtitle:
          "برای افزایش امنیت دارایی‌هایتان (هنگام برداشت، خرید و...)، پیشنهاد می‌کنیم ورود دو مرحله‌ای را فعال کنید.",
        inactiveButton: "غیرفعال کردن",
        items: [
          {
            title: "با موبایل",
            value: "sms"
          },
          {
            title: "با ایمیل",
            value: "email"
          },
          {
            title: "با گوگل (Google Authentication)",
            value: "google2fa"
          }
        ],
        hints: {
          mobile:
            "برای فعالسازی ورود دو مرحله با موبایل، لطفا ابتدا موبایل خود را ثبت و تایید کنید.",
          email:
            "برای فعالسازی ورود دو مرحله با ایمیل، لطفا ابتدا ایمیل خود را ثبت و تایید کنید.",
          google2fa:
            "برای فعالسازی ورود دو مرحله با گوگل (Google Authentication)، لطفا ابتدا Google Authentication خود را فعال کنید."
        }
      },
      modals: {
        activeDetails: {
          title: "ورود دو مرحله‌ای",
          subtitle: "برای دریافت کد تایید بر روی دکمه ”دریافت کد“ بزنید",
          getCodeButton: "دریافت کد"
        },
        activeEmail: {
          codeLabel: "کد تایید ایمیل"
        },
        activeGoogle: {
          codeLabel: "کد تایید گوگل (Google Authenticator)",
          title: "تایید با گوگل (Google Authenticator)",
          continue: "ادامه",
          stepper: [
            {
              id: 1,
              name: "انتخاب و روش دانلود",
              icon: "$downloadSaveUpload"
            },
            {
              id: 2,
              name: "ایجاد کد",
              icon: "$qrCode"
            },
            {
              id: 3,
              name: "فعالسازی",
              icon: "$doneCheck"
            }
          ],
          step1: {
            title: "دانلود اپلیکیشن",
            description: "میتوانید اپلیکیشن Google Authenticator را در پلتفرم های Android و IOS از طریق لینک زیر نصب کنید",
            getApp: "دریافت از",
            guid: "راهنمای تصویری نصب و استفاده از اپلیکیشن",

            activeAuto: {
              title: "حالت خودکار (روش پیشنهادی)",
              description: "جهت فعالسازی خودکار کد تایید با گوگل در برنامه Google Authenticator از این روش اقدام نمایید.",
              button : "فعال سازی خودکار",
              warning: "این حالت در اپلیکیشن موبایل قابل دسترس است."
            },
            activeManual: {
              title: "حالت دستی",
              description: "در صورتی که کد تایید با گوگل برای شما به صورت خودکار فعال نمی شود. با انتخاب روش دستی کد را فعال نمایید.",
              guid: "راهنمای تصویری فعال سازی تایید با گوگل",
              button : "فعال سازی دستی"
            },
            nextStepButton: "مرحله بعد"
          },
          step2: {
            description: 'این QR Code را در برنامه Google Authenticator اسکن کنید و یا کد زیر را به صورت دستی در برنامه وارد کنید.',
            warning: "دقت کنید، حتما کد زیر را در جایی یادداشت کنید",
            copy: "با موفقیت کپی شد.",
            guidSlider:{
              title: "افزودن کد در Google Authenticator",
              desc1: " شما باید کد 16 رقمی گوگل که در مرحله قبل داده شد را در برنامه Google Authenticator به‌صورت دستی اضافه کنید. برای اینکار می‌توانید از راهنمای زیر استفاده کنید.",
              desc2: " پس از ورود به برنامه، افزودن حساب را انتخاب کنید.",
              desc3: "سپس گزینه Enter a setup key  یا «وارد کردن کلید راه اندازی» را انتخاب کنید .",
              desc4: "در کادر Code Name برای کد خود یک نام انتخاب کنید سپس کلید راه اندازی را در کادر Your key جایگذاری کنید. نوع کلید باید time based یا «زمان محور» تنظیم شده باشد.",
              desc5: "این کد 6 رقمی برای حساب کاربری فعلی شما ایجاد شده و پس از اتمام مراحل فعالسازی، فعال خواهد شد.  در نظر داشته باشید که این کد یکبار مصرف هر 30 ثانیه تغییر خواهد کرد.",
            },
          },
          step3: {
            title: "فعال‌سازی کد",
            description: "کد 6 رقمی گوگل (Google Authenticator) را وارد کنید",
            warning: "اگر کد 6 رقمی را به درستی وارد میکنید اما با خطا مواجه می شوید، بررسی کنید؛ تنظیمات تاریخ و زمان تلفن دستگاه شما باید روی حالت خودکار (Automatic) قرار داشته باشد.",
            googleLabel: "کد 6 رقمی گوگل را وارد کنید",
            passwordLabel: "رمز عبور حساب کاربری اکسکوینو",
            emptyGoogleAuth: "کد 6 رقمی گوگل را وارد کنید",
            emptyPassword: "رمز عبور را وارد کنید",
          }
        },
        inactiveModal: {
          title: "غیرفعال کردن ورود دو مرحله‌ای (2FA)",
          warning:
            " غیرفعال کردن احراز هویت دو عاملی ، حساب شما را در معرض خطر بیشتری برای دسترسی غیرمجاز قرار می دهد. توصیه می شود که آن را در اسرع وقت دوباره فعال کنید.",
          passwordTitle: "رمز عبور خود را وارد کنید",
          passwordLabel: "رمز عبور",
          emptyPassword: "رمز عبور را وارد کنید",
          submitButton: "تایید"
        },
        activeSMS: {
          codeLabel: "کد تایید موبایل",
          step1: {
            title: "تایید شماره موبایل",
            subtitle: "شماره موبایل خود را وارد کنید",
            warning:
              " دقت کنید، شماره موبایلی که وارد می‌کنید، به عنوان شماره موبایل اصلی شما در نظر گرفته می‌شود و غیرقابل ویرایش می باشد",
            mobileLabel: "شماره موبایل",
            mobileHint: "مثلا 09123456789",
            nextStepButton: "ادامه"
          },
          step2: {
            title: "فعال کردن احراز هویت با پیامک",
            subtitle: "لطفا کد ارسال شده به ({n}) را وارد کنید.",
            codeLabel: "کد پیامک شده",
            resendCodeButton: "دریافت مجدد کد تایید",
            counterTitle: {
              part1: "ارسال مجدد کد تا",
              part2: "ثانیه دیگر"
            },
            passwordTitle: "رمز عبور خود را وارد کنید",
            passwordLabel: "رمز عبور",
            submitButton: "تایید",
            previousStepButton: "مرحله قبل"
          }
        },
        inactiveSMS: {
          title: "غیرفعال کردن احراز هویت با پیامک",
          warning:
            "  غیرفعال کردن احراز هویت دو عاملی ، حساب شما را در معرض خطر بیشتری برای دسترسی غیرمجاز قرار می دهد. توصیه می شود که آن را در اسرع وقت دوباره فعال کنید. پس از غیرفعال شدن احراز  دو عاملی ، در صورت شناسایی فعالیت غیرمعمول ، ممکن است به مدت 24 ساعت قادر به برداشت ریال و رمز ارز نباشید.",
          passwordTitle:
            " برای غیر‌فعال کردن احراز هویت با پیامک، لطفا رمز عبور خود را وارد کنید",
          passwordLabel: "رمز عبور",
          emptyPassword: "رمز عبور را وارد کنید",
          submitButton: "تایید"
        }
      }
    },
    username: {
      title: "نام کاربری",
      submitButton: "ثبت",
      modals: {
        addUsername: {
          title: "افزودن نام کاربری",
          warning:
            "توجه داشته باشید، نام کاربری که انتخاب می‌کنید غیرقابل تغییر می‌باشد. پس در انتخاب آن دقت کنید.",
          usernameLabel: "نام کاربری",
          usernameHints: {
            title: "نام کاربری شامل:",
            item1: "حداقل 4 و حداکثر 32 حرف باشد.",
            item2: "حروف باید انگلیسی باشد"
          },
          submitButton: "تایید"
        }
      }
    },
    password: {
      title: "رمز عبور",
      changeButton: "ویرایش",
      modals: {
        changePassword: {
          title: "ویرایش رمز عبور",
          currentPasswordLabel: "رمز عبور فعلی",
          emptyPassword: "رمز عبور فعلی را وارد کنید",
          newPasswordLabel: "رمز عبور جدید",
          emptyNewPassword: "رمز عبور جدید را وارد کنید",
          passwordHint: "رمز عبور باید شامل:",
          confirmNewPasswordLabel: "تکرار رمز عبور جدید",
          emptyConfirmNewPassword: "رمز عبور جدید را وارد کنید",
          submitButton: "تایید"
        }
      }
    },
    securityTwoFactorAuth: {
      watchVideoText: "مشاهده ویدیو راهنما",
      closeBtn: "بستن",
      watchGoogleGuid: "مشاهده راهنمای کامل فعال‌سازی Google Authenticator"
    },
    modals: {
      numberChange: {
        title: "تغییر شماره همراه",
        newNumber: "شماره همراه جدید",
        confirmationCode: "کد تایید موبایل جدید",
        warning:
          "کاربر گرامی برای حفاظت از دارایی و حساب کاربری شما،بعد از تغییر شماره همراه هرگونه برداشت از حساب کاربری به مدت 48  ساعت غیرفعال خواهد شد."
      },
      emailChange: {
        title: "تغییر ایمیل",
        newEmail: "ایمیل جدید",
        confirmationCode: "کد تایید ایمیل جدید",
        warning:
          "کاربر گرامی برای حفاظت از دارایی و حساب کاربری شما،بعد از تغییر ایمیل هرگونه برداشت از حساب کاربری به مدت 48 ساعت غیرفعال خواهد شد."
      },
      removeGoogleAuth: {
        title: "حذف آتنتیکیتور",
        otpCode: "کد ارسالی به ایمیل یا موبایل",
        warning:
          "کاربر گرامی برای حفاظت از دارایی و حساب کاربری شما،بعد از حذف گوگل آتنتیکیتور هرگونه برداشت از حساب کاربری به مدت 48 ساعت غیرفعال خواهد شد."
      },
      password: "رمز حساب کاربری",
      googleAuth: "گوگل اتنتیکیتور",
      confirm: "تایید",
      getCode: "دریافت کد",
      activate: "فعال سازی",
      codeSent: "کد تایید با موفقیت ارسال شد."
    }
  },
  accountSidebar: {
    unverified: "احراز هویت نشده",
    completeVerification: "تکمیل احراز هویت",
    totalAssets: "ارزش کل دارایی ها",
    profitLoss: "میزان سود (زیان) کل",
    links: {
      identity: {
        title: "اطلاعات هویتی",
        label: "تکمیل احراز هویت",
        description: "تکمیل، مشاهده و ویرایش اطلاعات هویتی"
      },
      bankInformation: {
        title: "اطلاعات بانکی",
        label: "",
        description: "مدیریت شماره شبا و شماره کارت‌های بانکی"
      },
      security: {
        title: "امنیت",
        label: "",
        description: "مدیریت رمز عبور، احراز هویت دو عاملی، نام کاربری"
      },
      referral: {
        title: "دعوت از دوستان",
        label: "",
        description: "دوستات رو دعوت کن، اکسکوین بگیر"
      },
      gifts: {
        title: "هدایا",
        label: "",
        description: "پاداش‌های مانده حساب و جشنواره‌ها"
      },
      ticketing: {
        title: "تیکت‌ها",
        label: "",
        description: "لیست تیکت‌های پشتیبانی"
      }
    },
    signOutButton: "خروج از حساب کاربری",
    referralCard: {
      introduceToFriends: "معرفی به دوستان",
      inviteGetExcoin: "دوستات رو دعوت کن، اکسکوین بگیر",
      referralCode: "کد معرف",
      referralCodeCopied: "کد معرف کپی شد"
    }
  },
  level: {
    title: "سطوح کاربری",
    accountLevelText: "شما کاربر {level} می‌باشید",
    enterToLevelBtn: "ورود به این سطح ",
    unlimitedText: "نامحدود",
    descriptionText: "توضیحات"
  },
  kyc: {
    checkText: "اطلاعات شما در حال بررسی است",
    checkText2:
      "بعد از بررسی و تایید اطلاعات، احراز هویت شما تکمیل شده و از طریق پیامک به شما اطلاع رسانی خواهد شد",
    autoKyc: {
      internationalCard: {
        guidTitle: "راهنمای عکس کارت ملی",
        originalImageText: "از اصل کارت ملی خود عکس بگیرید.",
        bgImageText: "پس‌زمینه‌ای که کارت ملی روی آن است تک‌رنگ باشد.",
        clearImageText: "عکس واضح و مشخص باشد.",
        blackAndWhiteImageText: "عکس سیاه و سفید نباشد.",
        notValidImageText: "کارت ملی قدیمی یا بدون اعتبار نباشد.",
        receiveInformationText: "در حال دریافت اطلاعات شما هستیم",
        delayText: "ممکن است چند ثانیه زمان ببرد",
        uploadCard: {
          onTheCardTitle: "انتخاب عکس روی کارت ملی",
          backTheCardTitle: "انتخاب عکس پشت کارت ملی"
        }
      },
      kycTypeSelection: {
        disableKyc: "در حال حاضر سیستم احراز هویت در دسترس نمی باشد",
        fillText: "لطفا احراز هویت خود را تکمیل کنید",
        accessToCompleteText:
          "برای تکمیل احراز هویت باید به کارت ملی هوشمند خود دسترسی داشته باشید.",
        fastRecognize: "شناسایی هویت سریع",
        recognizeIn10Sec: "شناسایی هویت در 10 دقیقه",
        inFastRecognize: "در شناسایی",
        recordVideoText: "شما باید ویدیویی از خود ضبط کنید.",
        autoProccessText: "فرآیند بررسی به صورت اتوماتیک انجام می‌شود.",
        startFastRecongnize: "شروع شناسایی",
        normalRecognize: "شناسایی هویت عادی",
        recognizeIn10Min: "شناسایی هویت در ۲ ساعت",
        inNormalRecognize: "در شناسایی هویت عادی",
        uploadImageText: "شما باید عکسی از خود گرفته یا آپلود کنید.",
        supportCheckProsseccText:
          "فرآیند بررسی توسط تیم پشتیبانی انجام می‌شود.",
        startNormalRecongnize: "شروع شناسایی هویت عادی",
        confidentionalInfoText:
          "اطلاعاتی که در بخش احراز هویت ثبت می‌کنید، فقط برای شناسایی هویت استفاده می‌شود و در اکسکوینو محرمانه و محفوظ است."
      },
      videoGuid: {
        recognizeVideoTitle: "ویدیو شناسایی هویت",
        toStartRecording:
          "برای شروع، به دوربین نگاه کنید و دستورالعمل‌های روی صفحه را دنبال کنید.",
        importantPoints: "نکات مهم",
        islamicPrinciplesText: "شئونات اسلامی را رعایت کنید.",
        fullFaceText: "تمام صورت خود را در کارد قرار دهید.",
        checkMicText: "نور و میکروفون خود را چک کنید.",
        readText:
          "متنی را که نمایش داده می‌شود، کاملا واضح و با صدای رسا بخوانید.",
        avoidHatText: "از گذاشتن کلاه خودداری کنید.",
        avoidEffectText: "از افکت روی ویدیو استفاده نکنید.",
        clickRecordAndRead:
          "روی دکمه ضبط ویدیو بزنید و متن زیر را کاملا واضح و با صدای رسا بخوانید:",
        acceptTerms:
          "جهت احراز هویت در سایت اکسکوینو؛ اینجانب قوانین سایت را مطالعه کردم و مسئولیت تمامی خرید و فروش‌ها از حساب کاربری‌ام را می‌پذیرم و حساب کاربری و کارت بانکی خود را در اختیار فرد دیگری قرار نمی‌دهم.",
        watchVideo: " مشاهده ویدیوی ضبط شده",
        recordVideoTitle: "ضبط ویدیو",
        stopVideoTitle: "توقف",
        recordAgainText: "ضبط مجدد ویديو",
        acceptAndContinue: "تایید و ادامه",
        gettingDataText: "در حال دریافت اطلاعات شما هستیم",
        delayText: "ممکن است چند ثانیه زمان ببرد "
      }
    },
    manualKyc: {
      imageSelectionTitle: "انتخاب عکس شناسایی هویت",
      takePhotoTitle: "گرفتن عکس شناسایی هویت با دوربین",
      takePhoto: {
        acceptPreviousConditionsText:
          "شرایط اعلام شده در بخش قبلی را رعایت کرده و روی دکمه گرفتن عکس بزنید.",
        checkTakenPhotoText:
          "عکس گرفته شده را بررسی کرده و اگر شرایط اعلام شده را داشت دکمه تایید و ادامه را بزنید.",
        blockedUsingCameraText: "شما دسترسی دوربین خود را مسدود کردید",
        activeUsingCameraText:
          "در صورت تمایل دسترسی دورین را از قسمت تنظیمات مرورگر فعال کنید",
        takePhotoTitle: "گرفتن عکس",
        takePhotoAgainBtn: "گرفتن مجدد عکس",
        acceptAndContinue: "تایید و ادامه"
      }
    },
    noWebcam: {
      doNotHaveWebcamText: "دستگاه من وب‌کم ندارد",
      continueIfDoNotHaveWebcamText:
        "اگر به وب‌کم دسترسی ندارید، می‌توانید روند احراز هویت را در اپلیکیشن اکسکوینو ادامه دهید",
      fastRecognizeTitle: "شناسایی هویت سریع",
      useExcoinoToRecognize:
        "برای ادامه روند احراز هویت، می‌توانید از اپلیکیشن اکسکوینو استفاده کنید",
      scanToDownoalBtn: "برای دانلود اسکن کنید",
      normalRecognizeTitle: "شناسایی هویت عادی ",
      inNormalRecognizeText: "در شناسایی هویت عادی",
      uploadPhotoText: "شما باید عکسی از خود آپلود کنید.",
      checkBySupportText: "فرآیند بررسی توسط تیم پشتیبانی انجام می‌شود.",
      startNormalRecognizeBtn: "شروع شناسایی هویت عادی "
    }
  },
  personal: {
    autoVerification: {
      identificationText: "شناسایی هویت"
    },
    persoanlKycStatus: {
      identificationText: "شناسایی هویت"
    }
  }
};
